import { IDropdownItem, IDropdownListSearch } from "../../../types/dropdownInterface";
import { BankDropdown, BankDropdownActionType } from "../../actionTypes/master/bankDropdownActionTypes";

export const getBankListDropdown = (payload: IDropdownListSearch): BankDropdownActionType => ({
  type: BankDropdown.GET_BANK_DROPDOWN_LIST,
  payload,
});

export const setBankListDropdown = (payload: Array<IDropdownItem>): BankDropdownActionType => ({
  type: BankDropdown.SET_BANK_DROPDOWN_LIST,
  payload,
});
